<template>
  <q-btn
    style="margin-top: -4px"
    dense
    round
    flat
    color="primary"
    icon="fas fa-plus"
    @click="addbutton()"
  />
</template>
<script>
export default {
  name: "add-button",
  methods: {
    addbutton() {
      console.log("addbuttonclicked");
      this.$emit("add");
    },
  },
};
</script>
